import { render, staticRenderFns } from "./ConfirmExit.vue?vue&type=template&id=495835cd&scoped=true"
import script from "./ConfirmExit.vue?vue&type=script&lang=js"
export * from "./ConfirmExit.vue?vue&type=script&lang=js"
import style0 from "./ConfirmExit.vue?vue&type=style&index=0&id=495835cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495835cd",
  null
  
)

export default component.exports